<template>
    <v-container
        id="users-containner"
        fluid
    >
        <v-row>
            <v-col class="col col-md-12">
                <v-toolbar flat>
                    <div class="d-flex justify-space-between align-center w-100p">
                        <v-toolbar-title>
                            Users
                        </v-toolbar-title>
                        <v-btn
                            v-if="isPermission"
                            class="ma-1 action-btn text-subtitle-2"
                            depressed
                            color="primary"
                            @click="addUser"
                        >
                            <v-icon
                                left
                                class="action-icon"
                            >
                                mdi-plus
                            </v-icon>
                            Add User
                        </v-btn>
                    </div>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row class="my-0">
            <v-col
                class="col col-md-3"
                style="height: 60px;"
            >
                <v-text-field
                    v-model="searchQuery"
                    label="Search user"
                    outlined
                    dense
                    append-icon="mdi-magnify"
                />
            </v-col>
            <v-col />
            <v-col
                class="col col-md-2 users__count"
            >
                <span>Total Users</span> {{ filteredCompanyUsers.length }}
            </v-col>
        </v-row>
        <v-card
            v-for="_user in filteredCompanyUsers"
            :key="_user.uid"
            class="mx-auto w-100p user__details mt-4"
            outlined
            @click="editUser(_user.uid)"
        >
            <v-list-item three-line>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ _user.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="my-3">
                        {{ _user.account }}
                        <v-chip
                            outlined
                            class="ml-2"
                        >
                            {{ _user.ingroup }}
                        </v-chip>
                    </v-list-item-subtitle>
                    <v-row class="user__contents">
                        <v-col class="col col-md-3 pl-4 pr-0 pt-4">
                            <span>Company: </span> {{ _user.company }}
                        </v-col>
                        <v-col class="col col-md-6 pl-0 pt-4">
                            <span>Email ID: </span> {{ _user.email ? _user.email : ' - ' }}
                        </v-col>
                    </v-row>
                    <v-row class="user__contents">
                        <v-col class="col col-md-3 pl-4 pr-0 pb-4">
                            <span>Created: </span> {{ formateDate(_user.created) }} ({{ fromNow(_user.created) }})
                        </v-col>
                        <v-col class="col col-md-6 pl-0 pb-4">
                            <span>Last Updated: </span> {{ formateDate(_user.updated) }} ({{ fromNow(_user.created) }})
                        </v-col>
                    </v-row>
                </v-list-item-content>
            </v-list-item>
            <v-icon class="mr-2">
                chevron_right
            </v-icon>
        </v-card>
    </v-container>
</template>

<script>
import moment from 'moment';
import { hasPermission } from '../../../utils/permissions';
import webtmsBackend from '@/services/webtmsBackend';

export default {
    data: () => ({
        searchQuery: null
    }),
    computed: {
        companyUsers() {
            return this.$store.getters.companyUsers;
        },
        user() {
            return this.$store.getters.user;
        },
        filteredCompanyUsers() {
            if(this.searchQuery){
                return this.companyUsers.filter((item)=>{
                    return this.searchQuery.toLowerCase().split(' ').every(v => item.name.toLowerCase().includes(v));
                });
            } else {
                return this.companyUsers;
            }
        },
        isPermission() {
            return hasPermission('USER_CREATE');
        }
    },
    async created() {
        const getUserResult = await webtmsBackend.getCompanyUsers();
        if(getUserResult) {
            this.$store.commit('SET_COMPANY_USERS', getUserResult.companyUsers);
        }
    },
    methods: {
        formateDate(date) {
            return moment(date).format('MM/DD/YYYY');
        },
        fromNow(date) {
            return moment(date).fromNow();
        },
        editUser(uid) {
            this.$router.push({ path: 'edituser', query: { id: uid }});
        },
        addUser() {
            this.$store.commit('SET_EDIT_USER', null);
            this.$router.push('adduser');
        }
    }
};
</script>

<style>
    .p-0 {
        padding: 0px;
    }
    .w-100p {
        width: 100%;
    }
    #users-containner .v-toolbar__content {
        padding: 0px;
    }
    .v-toolbar__title {
        font-weight: 500;
    }
    .users__count {
        text-align: end !important;
        font-weight: 500;
        font-size: 14px;
    }
    .users__count span {
        font-weight: 400;
        font-size: 12px;
        color: #7F8592;
        margin-top: 12px;
    }
    .user__details {
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .user__details .v-list-item__title {
        font-weight: 500;
        font-size: 20px;
        color: #1976D2;
    }
    .user__details .v-list-item__subtitle {
        font-weight: 400;
        font-size: 12px;
        color: #122448;
    }
    .user__details .v-list-item__subtitle .v-chip {
        font-weight: 400;
        font-size: 12px;
        color: #122448;
        height: 25px;
    }
    .user__contents .col {
        font-weight: 600;
        font-size: 12px;
        color: #35383F;
        padding: 0px;
    }
    .user__contents .col span {
        font-weight: 400;
        font-size: 12px;
        color: #35383F;
    }
</style>